import * as React from 'react';
const OrderContext = /*#__PURE__*/React.createContext(null);
export default OrderContext;